export const translations = {
    en: {
      // English translations
      nav: {
        about: "About",
        sectors: "Sectors",
        services: "Services",
        whyUs: "Why Us",
        contact: "Contact",
      },
      hero: {
        title: "Bridging Turkey and Chad",
        subtitle: "Your trusted partner in international trade",
        exploreButton: "Explore Sectors",
        contactButton: "Contact Us",
      },
      about: {
        title: "About Company",
        paragraph1: "Issaga Service & Consultant is a facilitator of international trade between Turkey and Chad. We specialize in connecting companies, exporters, and importers across various sectors including construction equipment, furniture, textile, military equipment, work clothes, perfumes, hardware supplies, and slippers.",
        paragraph2: "Our range of services covers a wide spectrum of products, ensuring optimal connections and smooth transactions between businesses in both countries. We take pride in our ability to foster strong partnerships and maintain high-quality product chains.",
        quote: "\"Like a seed sown with faith, Issaga Service & Consultant may seem small, but we grow to bear much fruit in the realm of international trade.\"",
      },
      sectors: {
        title: "Our Sectors",
        constructionEquipment: "Construction Equipment",
        furniture: "Furniture",
        foodIndustry: "Food Industry",
        militaryEquipment: "Military Equipment",
        workClothes: "Work Clothes",
        perfumes: "Perfumes",
        hardwareSupplies: "Hardware Supplies",
        slippers: "Slippers",
        carpets: "Carpets",
        healthTourism: "Health Tourism",
      },
      services: {
        title: "Our Services",
        businessMatchmaking: {
          title: "Business Matchmaking",
          description: "We connect Turkish exporters with Chadian importers, facilitating profitable partnerships across various sectors.",
        },
        marketResearch: {
          title: "Market Research",
          description: "Our team conducts in-depth market analysis to identify opportunities and trends in both Turkish and Chadian markets.",
        },
        contractNegotiation: {
          title: "Contract Negotiation",
          description: "We assist in negotiating and drafting international trade contracts to ensure fair and beneficial terms for all parties.",
        },
        logisticsCoordination: {
          title: "Logistics Coordination",
          description: "Our experts manage the complexities of international shipping and customs procedures for smooth transactions.",
        },
        financialAdvisory: {
          title: "Financial Advisory",
          description: "We provide guidance on international payment methods, currency exchange, and risk management strategies.",
        },
        growthConsulting: {
          title: "Growth Consulting",
          description: "Our consultants offer strategic advice to help businesses expand their international presence and operations.",
        },
      },
      whyChooseUs: {
        title: "Why Choose Us",
        intro: "Issaga Service & Consultancy believes in strong partnerships and quality product chains. We are connecting companies, exporters, and importers between Turkey and Chad in various sectors including construction equipment, furniture, food industry, military equipment, work and safety clothes, perfumes, hardware supplies, and slippers.",
        reasons: {
          bestQuality: {
            title: "Best Quality",
            description: "We believe in quality products and long-lasting strong partnerships in international trade.",
          },
          integrity: {
            title: "Integrity",
            description: "We are closer to our customers to hear from them and facilitate win-win business opportunities.",
          },
          strategy: {
            title: "Strategy",
            description: "We are strategic in connecting companies, exporters, and importers between Turkey and Chad across various sectors.",
          },
          safety: {
            title: "Safety",
            description: "Our shipping, payment, and other procedures are guaranteed and adhere to legal standards.",
          },
          timeValue: {
            title: "Time Value",
            description: "We value our customers' time in processing product exports, offering fast and quality service.",
          },
          globalReach: {
            title: "Global Reach",
            description: "Our extensive network spans Turkey and Chad, ensuring optimal connections for your business needs.",
          },
        },
      },
      contact: {
        title: "Contact Us",
        contactInfo: "Contact Information",
        name: "Name",
        email: "Email",
        message: "Message",
        sendMessage: "Send Message",
      },
      footer: {
        followUs: "Follow Us",
        rights: "© 2024 Issaga Service & Consultancy. All rights reserved.",
      },
    },
    fr: {
      // French translations
      nav: {
        about: "À propos",
        sectors: "Secteurs",
        services: "Services",
        whyUs: "Pourquoi nous",
        contact: "Contact",
      },
      hero: {
        title: "Relier la Turquie et le Tchad",
        subtitle: "Votre partenaire de confiance dans le commerce international",
        exploreButton: "Explorer les secteurs",
        contactButton: "Contactez-nous",
      },
      about: {
        title: "À propos de l'entreprise",
        paragraph1: "Issaga Service & Consultant est un facilitateur du commerce international entre la Turquie et le Tchad. Nous nous spécialisons dans la mise en relation d'entreprises, d'exportateurs et d'importateurs dans divers secteurs, notamment les équipements de construction, le mobilier, le textile, l'équipement militaire, les vêtements de travail, les parfums, les fournitures de quincaillerie et les pantoufles.",
        paragraph2: "Notre gamme de services couvre un large éventail de produits, assurant des connexions optimales et des transactions fluides entre les entreprises des deux pays. Nous sommes fiers de notre capacité à favoriser des partenariats solides et à maintenir des chaînes de produits de haute qualité.",
        quote: "\"Comme une graine semée avec foi, Issaga Service & Consultant peut sembler petite, mais nous grandissons pour porter beaucoup de fruits dans le domaine du commerce international.\"",
      },
      sectors: {
        title: "Nos secteurs",
        constructionEquipment: "Équipement de construction",
        furniture: "Mobilier",
        foodIndustry: "Industrie alimentaire",
        militaryEquipment: "Équipement militaire",
        workClothes: "Vêtements de travail",
        perfumes: "Parfums",
        hardwareSupplies: "Fournitures de quincaillerie",
        slippers: "Pantoufles",
        carpets: "Tapis",
        healthTourism: "Tourisme de santé",
      },
      services: {
        title: "Nos services",
        businessMatchmaking: {
          title: "Mise en relation d'entreprises",
          description: "Nous mettons en relation les exportateurs turcs avec les importateurs tchadiens, facilitant des partenariats rentables dans divers secteurs.",
        },
        marketResearch: {
          title: "Étude de marché",
          description: "Notre équipe mène des analyses de marché approfondies pour identifier les opportunités et les tendances sur les marchés turcs et tchadiens.",
        },
        contractNegotiation: {
          title: "Négociation de contrats",
          description: "Nous aidons à négocier et à rédiger des contrats de commerce international pour garantir des conditions équitables et bénéfiques pour toutes les parties.",
        },
        logisticsCoordination: {
          title: "Coordination logistique",
          description: "Nos experts gèrent les complexités des procédures d'expédition internationale et de douane pour des transactions fluides.",
        },
        financialAdvisory: {
          title: "Conseil financier",
          description: "Nous fournissons des conseils sur les méthodes de paiement international, le change de devises et les stratégies de gestion des risques.",
        },
        growthConsulting: {
          title: "Conseil en croissance",
          description: "Nos consultants offrent des conseils stratégiques pour aider les entreprises à étendre leur présence et leurs opérations internationales.",
        },
      },
      whyChooseUs: {
        title: "Pourquoi nous choisir",
        intro: "Issaga Service & Consultancy croit en des partenariats solides et des chaînes de produits de qualité. Nous mettons en relation des entreprises, des exportateurs et des importateurs entre la Turquie et le Tchad dans divers secteurs, notamment les équipements de construction, le mobilier, l'industrie alimentaire, l'équipement militaire, les vêtements de travail et de sécurité, les parfums, les fournitures de quincaillerie et les pantoufles.",
        reasons: {
          bestQuality: {
            title: "Meilleure qualité",
            description: "Nous croyons en des produits de qualité et des partenariats solides et durables dans le commerce international.",
          },
          integrity: {
            title: "Intégrité",
            description: "Nous sommes proches de nos clients pour les écouter et faciliter des opportunités commerciales gagnant-gagnant.",
          },
          strategy: {
            title: "Stratégie",
            description: "Nous sommes stratégiques dans la mise en relation d'entreprises, d'exportateurs et d'importateurs entre la Turquie et le Tchad dans divers secteurs.",
          },
          safety: {
            title: "Sécurité",
            description: "Nos procédures d'expédition, de paiement et autres sont garanties et respectent les normes légales.",
          },
          timeValue: {
            title: "Valeur du temps",
            description: "Nous valorisons le temps de nos clients dans le traitement des exportations de produits, offrant un service rapide et de qualité.",
          },
          globalReach: {
            title: "Portée mondiale",
            description: "Notre vaste réseau s'étend en Turquie et au Tchad, assurant des connexions optimales pour vos besoins commerciaux.",
          },
        },
      },
      contact: {
        title: "Contactez-nous",
        contactInfo: "Informations de contact",
        name: "Nom",
        email: "Email",
        message: "Message",
        sendMessage: "Envoyer le message",
      },
      footer: {
        followUs: "Suivez-nous",
        rights: "© 2024 Issaga Service & Consultancy. Tous droits réservés.",
      },
    },
    tr: {
      // Turkish translations
      nav: {
        about: "Hakkımızda",
        sectors: "Sektörler",
        services: "Hizmetler",
        whyUs: "Neden Biz",
        contact: "İletişim",
      },
      hero: {
        title: "Türkiye ve Çad arasında köprü oluyoruz",
        subtitle: "Uluslararası ticarette güvenilir ortağınız",
        exploreButton: "Sektörleri Keşfet",
        contactButton: "Bize Ulaşın",
      },
      about: {
        title: "Şirket Hakkında",
        paragraph1: "Issaga Service & Consultant, Türkiye ve Çad arasındaki uluslararası ticaretin bir kolaylaştırıcısıdır. İnşaat ekipmanları, mobilya, tekstil, askeri ekipman, iş kıyafetleri, parfümler, hırdavat malzemeleri ve terlikler dahil olmak üzere çeşitli sektörlerde şirketleri, ihracatçıları ve ithalatçıları bir araya getirme konusunda uzmanız.",
        paragraph2: "Hizmet yelpazemiz geniş bir ürün yelpazesini kapsamakta olup, her iki ülkedeki işletmeler arasında optimum bağlantılar ve sorunsuz işlemler sağlamaktadır. Güçlü ortaklıklar kurma ve yüksek kaliteli ürün zincirleri sürdürme yeteneğimizle gurur duyuyoruz.",
        quote: "\"İnançla ekilen bir tohum gibi, Issaga Service & Consultant küçük görünebilir, ancak uluslararası ticaret alanında çok meyve vermek için büyüyoruz.\"",
      },
      sectors: {
        title: "Sektörlerimiz",
        constructionEquipment: "İnşaat Ekipmanları",
        furniture: "Mobilya",
        foodIndustry: "Gıda Endüstrisi",
        militaryEquipment: "Askeri Ekipman",
        workClothes: "İş Kıyafetleri",
        perfumes: "Parfümler",
        hardwareSupplies: "Hırdavat Malzemeleri",
        slippers: "Terlikler",
        carpets: "Halılar",
        healthTourism: "Sağlık Turizmi",
      },
      services: {
        title: "Hizmetlerimiz",
        businessMatchmaking: {
          title: "İş Eşleştirme",
          description: "Türk ihracatçıları ile Çadlı ithalatçıları bir araya getirerek çeşitli sektörlerde karlı ortaklıklar kuruyoruz.",
        },
        marketResearch: {
          title: "Pazar Araştırması",
          description: "Ekibimiz, hem Türkiye hem de Çad pazarlarındaki fırsatları ve trendleri belirlemek için derinlemesine pazar analizleri yapmaktadır.",
        },
        contractNegotiation: {
          title: "Sözleşme Müzakeresi",
          description: "Tüm taraflar için adil ve faydalı şartlar sağlamak amacıyla uluslararası ticaret sözleşmelerinin müzakere edilmesine ve hazırlanmasına yardımcı oluyoruz.",
        },
        logisticsCoordination: {
          title: "Lojistik Koordinasyonu",
          description: "Uzmanlarımız, sorunsuz işlemler için uluslararası nakliye ve gümrük prosedürlerinin karmaşıklıklarını yönetmektedir.",
        },
        financialAdvisory: {
          title: "Finansal Danışmanlık",
          description: "Uluslararası ödeme yöntemleri, döviz alım satımı ve risk yönetimi stratejileri konularında rehberlik sağlıyoruz.",
        },
        growthConsulting: {
          title: "Büyüme Danışmanlığı",
          description: "Danışmanlarımız, işletmelerin uluslararası varlıklarını ve operasyonlarını genişletmelerine yardımcı olmak için stratejik tavsiyeler sunmaktadır.",
        },
      },
      whyChooseUs: {
        title: "Neden Bizi Seçmelisiniz",
        intro: "Issaga Service & Consultancy, güçlü ortaklıklara ve kaliteli ürün zincirlerine inanmaktadır. İnşaat ekipmanları, mobilya, gıda endüstrisi, askeri ekipman, iş ve güvenlik kıyafetleri, parfümler, hırdavat malzemeleri ve terlikler dahil olmak üzere çeşitli sektörlerde Türkiye ve Çad arasında şirketleri, ihracatçıları ve ithalatçıları bir araya getiriyoruz.",
        reasons: {
          bestQuality: {
            title: "En İyi Kalite",
            description: "Uluslararası ticarette kaliteli ürünlere ve uzun ömürlü güçlü ortaklıklara inanıyoruz.",
          },
          integrity: {
            title: "Dürüstlük",
            description: "Müşterilerimizi dinlemek ve kazan-kazan iş fırsatlarını kolaylaştırmak için onlara daha yakınız.",
          },
          strategy: {
            title: "Strateji",
            description: "Türkiye ve Çad arasında çeşitli sektörlerde şirketleri, ihracatçıları ve ithalatçıları bir araya getirmede stratejik davranıyoruz.",
          },
          safety: {
            title: "Güvenlik",
            description: "Nakliye, ödeme ve diğer prosedürlerimiz garantilidir ve yasal standartlara uygundur.",
          },
          timeValue: {
            title: "Zaman Değeri",
            description: "Ürün ihracatlarını işlerken müşterilerimizin zamanına değer veriyor, hızlı ve kaliteli hizmet sunuyoruz.",
          },
          globalReach: {
            title: "Küresel Erişim",
            description: "Geniş ağımız Türkiye ve Çad'ı kapsıyor, iş ihtiyaçlarınız için optimum bağlantılar sağlıyoruz.",
          },
        },
      },
      contact: {
        title: "Bize Ulaşın",
        contactInfo: "İletişim Bilgileri",
        name: "İsim",
        email: "E-posta",
        message: "Mesaj",
        sendMessage: "Mesaj Gönder",
      },
      footer: {
        followUs: "Bizi Takip Edin",
        rights: "© 2024 Issaga Service & Consultancy. Tüm hakları saklıdır.",
      },
    },
    ar: {
      // Arabic translations
      nav: {
        about: "حول",
        sectors: "القطاعات",
        services: "الخدمات",
        whyUs: "لماذا نحن",
        contact: "اتصل بنا",
      },
      hero: {
        title: "الربط بين تركيا وتشاد",
        subtitle: "شريكك الموثوق في التجارة الدولية",
        exploreButton: "استكشف القطاعات",
        contactButton: "اتصل بنا",
      },
      about: {
        title: "عن الشركة",
        paragraph1: "Issaga Service & Consultant هو ميسر للتجارة الدولية بين تركيا وتشاد. نحن متخصصون في ربط الشركات والمصدرين والمستوردين عبر قطاعات مختلفة بما في ذلك معدات البناء والأثاث والمنسوجات والمعدات العسكرية وملابس العمل والعطور ومستلزمات الأجهزة والشباشب.",
        paragraph2: "تغطي مجموعة خدماتنا طيفًا واسعًا من المنتجات، مما يضمن الاتصالات المثلى والمعاملات السلسة بين الشركات في كلا البلدين. نحن نفخر بقدرتنا على تعزيز الشراكات القوية والحفاظ على سلاسل المنتجات عالية الجودة.",
        quote: "\"مثل البذرة المزروعة بإيمان، قد تبدو Issaga Service & Consultant صغيرة، لكننا ننمو لنثمر كثيرًا في مجال التجارة الدولية.\"",
      },
      sectors: {
        title: "قطاعاتنا",
        constructionEquipment: "معدات البناء",
        furniture: "الأثاث",
        foodIndustry: "صناعة الأغذية",
        militaryEquipment: "المعدات العسكرية",
        workClothes: "ملابس العمل",
        perfumes: "العطور",
        hardwareSupplies: "مستلزمات الأجهزة",
        slippers: "الشباشب",
        carpets: "السجاد",
        healthTourism: "السياحة الصحية",
      },
      services: {
        title: "خدماتنا",
        businessMatchmaking: {
          title: "مطابقة الأعمال",
          description: "نقوم بربط المصدرين الأتراك بالمستوردين التشاديين، مما يسهل الشراكات المربحة عبر مختلف القطاعات.",
        },
        marketResearch: {
          title: "أبحاث السوق",
          description: "يقوم فريقنا بإجراء تحليلات معمقة للسوق لتحديد الفرص والاتجاهات في كل من الأسواق التركية والتشادية.",
        },
        contractNegotiation: {
          title: "التفاوض على العقود",
          description: "نساعد في التفاوض وصياغة عقود التجارة الدولية لضمان شروط عادلة ومفيدة لجميع الأطراف.",
        },
        logisticsCoordination: {
          title: "تنسيق الخدمات اللوجستية",
          description: "يدير خبراؤنا تعقيدات إجراءات الشحن الدولي والجمارك للمعاملات السلسة.",
        },
        financialAdvisory: {
          title: "الاستشارات المالية",
          description: "نقدم التوجيه بشأن طرق الدفع الدولية وصرف العملات واستراتيجيات إدارة المخاطر.",
        },
        growthConsulting: {
          title: "استشارات النمو",
          description: "يقدم مستشارونا نصائح استراتيجية لمساعدة الشركات على توسيع وجودها وعملياتها الدولية.",
        },
      },
      whyChooseUs: {
        title: "لماذا تختارنا",
        intro: "تؤمن Issaga Service & Consultancy بالشراكات القوية وسلاسل المنتجات عالية الجودة. نحن نربط الشركات والمصدرين والمستوردين بين تركيا وتشاد في قطاعات مختلفة بما في ذلك معدات البناء والأثاث وصناعة الأغذية والمعدات العسكرية وملابس العمل والسلامة والعطور ومستلزمات الأجهزة والشباشب.",
        reasons: {
          bestQuality: {
            title: "أفضل جودة",
            description: "نحن نؤمن بالمنتجات عالية الجودة والشراكات القوية طويلة الأمد في التجارة الدولية.",
          },
          integrity: {
            title: "النزاهة",
            description: "نحن أقرب إلى عملائنا للاستماع إليهم وتسهيل فرص الأعمال المربحة للجانبين.",
          },
          strategy: {
            title: "الاستراتيجية",
            description: "نحن استراتيجيون في ربط الشركات والمصدرين والمستوردين بين تركيا وتشاد عبر مختلف القطاعات.",
          },
          safety: {
            title: "السلامة",
            description: "إجراءات الشحن والدفع وغيرها من الإجراءات لدينا مضمونة وتتوافق مع المعايير القانونية.",
          },
          timeValue: {
            title: "قيمة الوقت",
            description: "نحن نقدر وقت عملائنا في معالجة صادرات المنتجات، ونقدم خدمة سريعة وعالية الجودة.",
          },
          globalReach: {
            title: "الوصول العالمي",
            description: "تمتد شبكتنا الواسعة عبر تركيا وتشاد، مما يضمن الاتصالات المثلى لاحتياجات أعمالك.",
          },
        },
      },
      contact: {
        title: "اتصل بنا",
        contactInfo: "معلومات الاتصال",
        name: "الاسم",
        email: "البريد الإلكتروني",
        message: "الرسالة",
        sendMessage: "إرسال الرسالة",
      },
      footer: {
        followUs: "تابعنا",
        rights: "© 2024 Issaga Service & Consultancy. جميع الحقوق محفوظة.",
      },
    },
  };